import { Center, Spinner } from '@chakra-ui/react'
import * as React from 'react'
import { Helmet } from 'react-helmet-async'
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom'
import { decodeHash } from '../../../utils'
import { UrlEndpointsForm } from '../../components/UrlEndpoints/UrlEndpointsForm'
import type { SourcesResponse, UrlEndpointsResponse, UrlEndpointFunctionInfo } from '../../interfaces'

interface Props {
  sources?: SourcesResponse[]
  urlEndpoints?: UrlEndpointsResponse[]
  loadingUrlEndpoints: boolean
  loadingSources: boolean
  refreshUrlEndpoints(): void
  refreshSources(): void
  urlEndpointFunctions:UrlEndpointFunctionInfo[]
}

const UrlEndpointsPage = ({
  sources,
  refreshUrlEndpoints,
  refreshSources,
  urlEndpoints,
  loadingUrlEndpoints,
  loadingSources,
  urlEndpointFunctions,
}: Props): React.ReactElement => {
  const { path } = useRouteMatch()

  let { urlEndpointId } = useParams<{ urlEndpointId: string }>()
  urlEndpointId = decodeHash(urlEndpointId) as string

  const urlEndpoint = urlEndpoints?.filter(
    endpoint => endpoint.id === urlEndpointId,
  )[0]

  if (loadingUrlEndpoints || loadingSources || !urlEndpoints) {
    return (
      <Center height="100%">
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="appPaleGrey"
          color="appBlue"
          size="xl"
        />
      </Center>
    )
  }

  if (!urlEndpoint) {
    return <React.Fragment>404 Not Found</React.Fragment>
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>URL Endpoints</title>
        <meta name="description" content="URL Endpoints page" />
      </Helmet>

      <Switch>
        <Route
          exact
          path={`${path}`}
          render={() => (
            <UrlEndpointsForm
              urlEndpoint={urlEndpoint}
              sources={sources}
              refreshUrlEndpoints={refreshUrlEndpoints}
              refreshSources={refreshSources}
              loadingUrlEndpoints={loadingUrlEndpoints}
              loadingSources={loadingSources}
              urlEndpointFunctions={urlEndpointFunctions}
            />
          )}
        />
      </Switch>
    </React.Fragment>
  )
}

export default UrlEndpointsPage
